import { Alert, Box, Button, Chip } from '@mui/material';
import { usePartyManager } from './PartyManagerContext';

const PartyAlert = ({
  pendingMatchConfirmation,
  pendingImportConfirmation,
  alert,
  onConfirmMatch,
  onCancelMatch,
  onConfirmImport,
  onCancelImport,
  isPerson,
  onCloseAlert,
}) => {
  const { partyData } = usePartyManager();

  if (pendingMatchConfirmation) {
    const { fieldKey } = pendingMatchConfirmation;
    const entityType = isPerson ? 'Kontakt' : 'Firma';
    const searchFieldDescription =
      fieldKey === 'customerNumber'
        ? `mit der Kundennummer "${partyData.customerNumber[partyData.customerNumber['selected']]}"`
        : fieldKey === 'supplierNumber'
          ? `mit der Lieferantennummer "${partyData.supplierNumber[partyData.supplierNumber['selected']]}"`
          : `mit der E-Mail-Adresse "${partyData.email[partyData.email['selected']]}"`;

    return (
      <Alert severity="info" sx={{ my: 1.5 }}>
        <Box>
          In unserer Datenbank ist bereits ein{isPerson ? ` ` : `e `}
          {entityType} {searchFieldDescription} vorhanden. Möchten Sie in die
          Bearbeitung wechseln?
          <Box
            sx={{
              mt: 1,
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 1,
            }}
          >
            <Button
              onClick={onCancelMatch}
              variant="text"
              color="info"
              size="small"
            >
              Abbrechen
            </Button>
            <Button
              onClick={onConfirmMatch}
              variant="contained"
              color="info"
              sx={{ '&:hover': { backgroundColor: '#1976d2' } }}
              autoFocus
              size="small"
            >
              Zur Bearbeitung
            </Button>
          </Box>
        </Box>
      </Alert>
    );
  }

  if (pendingImportConfirmation) {
    const sources = pendingImportConfirmation.externalResults
      .map((r) => r.source)
      .map((s) => s.charAt(0).toUpperCase() + s.slice(1));

    const { fieldKey } = pendingImportConfirmation;
    const entityType = isPerson ? 'Kontakt' : 'Firma';
    const searchFieldDescription =
      fieldKey === 'customerNumber'
        ? `mit der Kundennummer "${partyData.customerNumber[partyData.customerNumber['selected']]}"`
        : fieldKey === 'supplierNumber'
          ? `mit der Lieferantennummer "${partyData.supplierNumber[partyData.supplierNumber['selected']]}"`
          : `mit der E-Mail-Adresse "${partyData.email[partyData.email['selected']]}"`;

    return (
      <Alert severity="info" sx={{ my: 1.5 }}>
        <Box>
          Es wurde ein{isPerson ? ` ` : `e `}
          {entityType} {searchFieldDescription} in den folgenden Quellen
          gefunden:{' '}
          {sources.map((source) => (
            <Chip
              key={source}
              label={source}
              variant="outlined"
              size="small"
              sx={{ mr: 0.5 }}
              color="info"
            />
          ))}
          <Box
            sx={{
              mt: 1,
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 1,
            }}
          >
            <Button
              onClick={onCancelImport}
              variant="text"
              color="info"
              size="small"
            >
              Abbrechen
            </Button>
            <Button
              onClick={onConfirmImport}
              variant="contained"
              color="info"
              sx={{ '&:hover': { backgroundColor: '#1976d2' } }}
              autoFocus
              size="small"
            >
              Zum Import
            </Button>
          </Box>
        </Box>
      </Alert>
    );
  }

  if (alert.open) {
    return (
      <Alert
        severity={alert.type}
        sx={{
          my: 1.5,
          alignItems: 'flex-start',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          <Box>{alert.message}</Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
            <Button color="inherit" size="small" onClick={onCloseAlert}>
              VERSTANDEN
            </Button>
          </Box>
        </Box>
      </Alert>
    );
  }

  return null;
};

export default PartyAlert;
